function debounce(func: any, wait: any) {
  let timeout: any;
  return function (this: any, ...args: any) {
    const context = this;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      timeout = null;
      if (typeof func === "function") func.apply(context, args);
    }, wait);
  };
}

export default debounce;
